import { gql, TypedDocumentNode } from '@apollo/client';
import type { PurchaseOrder } from '../models/PurchaseOrder';

export const ADD_PURCHASEORDER_MUTATION: TypedDocumentNode<{ added: boolean }, { input: PurchaseOrder }> = gql`
  mutation AddPurchaseOrder($input: PurchaseOrderModelInput!) {
    added: addPurchaseOrder(input: $input)
  }
`;
